import { Button } from "antd";
import styled from "styled-components";

export const RegisterButton = styled(Button)`
  height: 40px;
  width: 140px;
`;

export const CancelButton = styled(Button)`
  height: 40px;
  width: 140px;
  border: 1px solid ${(props) => props.theme.colors.manatee};
`;
